export const DisclaimerBlock = ({ label = "Límite operativo", children }) => (
  <aside data-testid="disclaimer-block" className="border border-onix-line bg-transparent p-7 md:p-9">
    <p className="eyebrow mb-4 flex items-center gap-3">
      <span className="w-2 h-2 border border-onix-silver rotate-45 inline-block" aria-hidden="true" />
      {label}
    </p>
    <div className="text-sm md:text-[0.95rem] leading-relaxed text-onix-silver">{children}</div>
  </aside>
);
